// extracted by mini-css-extract-plugin
export default {"text":"RecentStudies_text__C77zO","background":"RecentStudies_background__1sJqd","nonStudy":"RecentStudies_nonStudy__3+K0T"};